export type DeleteComponentConversionRulesRequest = {
  envCopyCpntAttrCnvRule: {
    idx: number;
    cpntAttrCnvRuleId: string;
    updateDateTime: string;
  }[];
};
